module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "outil-item bg-gray-100 min-h-screen flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('app-header', {
    staticClass: "text-white pt-4 px-4",
    attrs: {
      "icon": "tools"
    }
  }, [_c('h1', {
    staticClass: "text-2xl flex items-center gap-3"
  }, [_c('span', [_vm._v("Outillage")])])]), _vm._v(" "), _c('action-bar', {
    staticClass: "px-4 pb-6",
    attrs: {
      "back": {
        name: 'liste-outils'
      }
    }
  }, [_c('a', {
    staticClass: "btn btn-full main-action inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-lg px-4 py-2 shadow-sm hover:shadow transition text-white",
    class: [(_vm.outil.actif ? 'actif bg-success' : 'inactif bg-alert')],
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchOutil($event)
      }
    }
  }, [_c('i', {
    class: _vm.outil.actif ? 'icon-valid' : 'icon-error'
  }), _vm._v(" "), _c('span', {
    staticClass: "text-sm sm:text-base"
  }, [_vm._v("\n                    Outillage\n                    "), _c('strong', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.action))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [_c('div', {
    staticClass: "m-2 shadow-2xl rounded-xl overflow-hidden mb-8 bg-white"
  }, [_c('div', {
    staticClass: "p-4 md:p-6"
  }, [_c('h2', {
    staticClass: "text-lg mb-4 uppercase text-secondary"
  }, [_vm._v("\n                    Informations sur votre\n                    "), (_vm.outil.type_outil) ? _c('b', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.outil.type_outil.nom))]) : _vm._e(), _vm._v(" :\n                ")]), _vm._v(" "), _c('form', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4",
    attrs: {
      "method": "post",
      "id": "outil"
    }
  }, [_c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Marque")]), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "title": "mark",
      "type": "text",
      "name": "marque",
      "readonly": ""
    },
    domProps: {
      "value": _vm.outil.marque
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom de l'appareil")]), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "title": "appareilName",
      "type": "text",
      "name": "nom",
      "readonly": ""
    },
    domProps: {
      "value": _vm.outil.modele
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Numéro de série")]), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "title": "idNumber",
      "type": "text",
      "name": "numero",
      "readonly": ""
    },
    domProps: {
      "value": _vm.outil.numero_serie
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Distributeur")]), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "title": "dist",
      "type": "text",
      "name": "fournisseur",
      "readonly": ""
    },
    domProps: {
      "value": _vm.outil.magasin
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Date d'achat")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateAchat),
      expression: "dateAchat"
    }],
    staticClass: "input",
    attrs: {
      "title": "buyAt",
      "type": "date",
      "name": "date_achat",
      "id": "date_achat",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.dateAchat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateAchat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("N°facture")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outil.facture_achat),
      expression: "outil.facture_achat"
    }],
    staticClass: "input",
    attrs: {
      "title": "invoiceNumber",
      "type": "text",
      "name": "facture_achat",
      "id": "facture_achat",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.outil.facture_achat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.outil, "facture_achat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("N°bon de livraison")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outil.bon_livraison),
      expression: "outil.bon_livraison"
    }],
    staticClass: "input",
    attrs: {
      "title": "deliveryAt",
      "type": "text",
      "name": "bon_livraison",
      "id": "bon_livraison",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.outil.bon_livraison)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.outil, "bon_livraison", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Dernier contrôle")]), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "title": "lastControl",
      "type": "date",
      "name": "last_controle",
      "id": "last_controle",
      "readonly": ""
    },
    domProps: {
      "value": _vm.dateLastControle
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ee13ae2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/outil/Outil.vue
// module id = 1003
// module chunks = 0